import React from "react";
import useMailMessageControls from "../../../hooks/useMailMessageControls";
import Button, { IconButton } from "../../../components/buttons";
import { ButtonGroup } from "react-bootstrap";
import { ThemedSpan } from "../../../components/utilities";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DateDisplay } from "../../../components";
import { useCallback } from "react";
import { usePersonalOutlookContext } from "../../../hooks/PersonalOutlookContext";

const EmailHeader = ({ data }) => {
    const { mailDelegateRightsResult } = usePersonalOutlookContext();
    const { searchTerm, selectedFolderId } = usePersonalOutlookContext();
    const { onFile, onForward, onReply, onReplyAll } = useMailMessageControls(
        data,
        mailDelegateRightsResult?.data,
        { folderId: selectedFolderId, searchTerm }
    );

    const {
        subject,
        from,
        sentDateTime,
        toRecipients,
        ccRecipients,
        bccRecipients,
        isFiled
    } = data || {};

    const getRecipientListText = useCallback((recipients) => recipients?.map(x => x.emailAddress?.name ?? x.emailAddress?.address).join(", "), []);

    const bccDisplayText = React.useMemo(() => getRecipientListText(bccRecipients), [bccRecipients]);

    const ccDisplayText = React.useMemo(() => getRecipientListText(ccRecipients), [ccRecipients]);

    const fromDisplayText = React.useMemo(() => from?.emailAddress?.name
        ? `${from?.emailAddress?.name} <${from?.emailAddress?.address}>`
        : from?.emailAddress?.address, [from]);

    const toDisplayText = React.useMemo(() => getRecipientListText(toRecipients), [toRecipients]);

    return (
        <React.Fragment>
            <div className="row mb-2">
                <h4 className="col">{subject}</h4>
                <div className="col-auto">
                    <IconButton
                        className="me-2"
                        disabled={isFiled}
                        variant={isFiled ? "success" : "danger"}
                        icon={isFiled ? "file-circle-check" : "file-circle-xmark"}
                        size="lg"
                        onClick={onFile}
                    />
                </div>
            </div>
            <div className="row">
                <div className="d-flex justify-content-between">
                    <div className="d-flex flex-row align-items-center">
                        <div className="d-flex flex-column">
                            <ThemedSpan><b>{fromDisplayText}</b></ThemedSpan>
                            <ThemedSpan>To: {toDisplayText}</ThemedSpan>
                            {bccRecipients?.length > 0 && <ThemedSpan>Bcc: {bccDisplayText}</ThemedSpan>}
                            {ccRecipients?.length > 0 && <ThemedSpan>Cc: {ccDisplayText}</ThemedSpan>}
                        </div>
                    </div>
                    {<div className="d-flex flex-column">
                        <ButtonGroup>
                            <Button className="border" onClick={onReply}>
                                <FontAwesomeIcon icon={"fa-reply"} className="me-2" />
                                Reply
                            </Button>
                            <Button className="border" onClick={onReplyAll}>
                                <FontAwesomeIcon icon={"fa-reply-all"} className="me-2" />
                                Reply All
                            </Button>
                            <Button className="border" onClick={onForward}>
                                <FontAwesomeIcon icon={"fa-share"} className="me-2" />
                                Forward
                            </Button>
                        </ButtonGroup>
                        <ThemedSpan className="text-end">
                            <DateDisplay format="ddd Do MMM YYYY HH:mm">{sentDateTime}</DateDisplay>
                        </ThemedSpan>
                    </div>}
                </div>
            </div>
        </React.Fragment>
    );
};

export default EmailHeader;